// extracted by mini-css-extract-plugin
export default {"Container":"leave_Container__cS85w"};